export const Category_VitalSigns = 'vital-signs';
export const Category_SocialHistory = 'social-history';
export const FHIR_Observation_CategoryOptions = [
    Category_VitalSigns,
    Category_SocialHistory
];
export const FHIR_Observation_CategoryOptions_ToLabelsMap = {
    [Category_VitalSigns]: 'Vital Signs',
    [Category_SocialHistory]: 'Social History',
};
export const SocialHistory_Code_Pregnancy = '82810-3';
export const SocialHistory_Code_Menstrual = '3146-8';
export const SocialHistory_Code_Lactation = '63895-7';
export const SocialHistory_Code_SmokingHistory = '72166-2';
export const SocialHistory_Code_PhysicalFindingsOfUterus = '32486-3';
export const SocialHistory_Code_EstimatedDeliveryDate = '11778-8';
export const SocialHistory_Code_LastMenstrualPeriod = '8665-2';
export const SocialHistory_Code_PregnancyIntention = '86645-9';
export const FHIR_Observation_StatusOptions = [
    SocialHistory_Code_Pregnancy,
    SocialHistory_Code_Menstrual,
    SocialHistory_Code_Lactation,
    SocialHistory_Code_SmokingHistory,
    SocialHistory_Code_PhysicalFindingsOfUterus,
    SocialHistory_Code_EstimatedDeliveryDate,
    SocialHistory_Code_LastMenstrualPeriod,
    SocialHistory_Code_PregnancyIntention
];
export const FHIR_Observation_CodeOptions_ToLabelsMap = {
    [SocialHistory_Code_Pregnancy]: 'Pregnancy Status',
    [SocialHistory_Code_Menstrual]: 'Menstrual Status',
    [SocialHistory_Code_Lactation]: 'Lactation Status',
    [SocialHistory_Code_SmokingHistory]: 'Smoking History',
    [SocialHistory_Code_PhysicalFindingsOfUterus]: 'Physical Findings of Uterus',
    [SocialHistory_Code_EstimatedDeliveryDate]: 'Estimated Delivery Date',
    [SocialHistory_Code_LastMenstrualPeriod]: 'Last Menstrual Period',
    [SocialHistory_Code_PregnancyIntention]: 'Pregnancy Intention',
};
//# sourceMappingURL=consts.js.map